import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NavController } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { RetailCartService } from 'src/app/services/retail/retail-cart.service';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';

@Component({
  selector: 'product-card-list',
  templateUrl: './product-card-list.component.html',
  styleUrls: ['./product-card-list.component.scss'],
})
export class ProductCardListComponent implements OnInit {
  @Input() productsList: any;
  @Input() noPaging: boolean;
  @Output() getNextPage = new EventEmitter<Event>();
  public currencyCode: string;
  imagePlaceholder = '../../../assets/icons/trvlxx180.png';
  constructor(private navControl: NavController, private loaderService: LoaderService, private retailCartService: RetailCartService, private i18ConfigService: I18ConfigService,
  ) {
    this.currencyCode = i18ConfigService.getCurrency();
  }

  ngOnInit() { }

  navigateToNextPage(productItem) {
    this.navControl.navigateForward(['shopping/retail/product/', productItem.id, { loc: productItem.locationId, storeId: productItem.storeId }]);
  }

  getNextPageFromParent(event) {
    this.getNextPage.emit(event);
  }


}
